import Languages from '../../../../utils/Languages.js'
import {escapedTemplate} from '../../../utils/escapeHtml.js'
import {addressLines, button, card, codeBox, field, intro, mailDocument, multiline, stack} from './mailLayout.js'

const template = ({
    logo,
    color = '',
    message,
    parcel,
    verificationCodeText = Languages.mailVerificationCodeRequired.NL,
    addressHeader = Languages.deliveryAddress.NL,
    senderHeader = Languages.consignor.NL,
    referenceHeader = Languages.reference.NL,
    barcodeHeader = Languages.mailTrackTrace.NL,
    buttonText = Languages.followShipment.NL,
    address
}, baseUrl?: string) => {
    const senderAddress = parcel?.senderAddress || {}
    const accent = color || '#ff751a'

    return mailDocument({
        logo,
        color: accent,
        baseUrl,
        content: stack([
            intro(multiline(message)),
            card([
                field(addressHeader, addressLines(address)),
                field(senderHeader, senderAddress.name || ''),
                parcel?.reference && field(referenceHeader, parcel.reference),
                field(barcodeHeader, parcel?.trackTrace || ''),
                parcel?.verificationCode && codeBox(parcel.verificationCode, verificationCodeText),
                button(buttonText, parcel?.trackTraceLink || null, accent)
            ])
        ])
    })
}

export default escapedTemplate(template)
